<parkour-page-gradient classes="absolute top-0 left-0 before:-translate-y-[5rem]" />

<div class="relative z-10 pt-8 flex flex-col gap-y-8 container container-space h-full">
  <div class="flex flex-col items-center gap-4 container-1-col">
    <ng-content select="[hero-image]"></ng-content>
    <h1>{{ title }}</h1>
    <parkour-divider></parkour-divider>
  </div>
  <ng-content></ng-content>
</div>
